import { Network } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import type { Investigation } from '@/types/investigation'
import { DetailSection } from './DetailSection'
import { GridSnapshotPill, ObjectsSetPanel } from './InvestigationDossier'

export function InvestigationObjectsCard({ inv }: { inv: Investigation }) {
  const { t } = useTranslation()
  return (
    <DetailSection
      icon={<Network className="size-4" />}
      title={t('investigations.page.featured.objectsSet')}
      meta={
        <span className="inline-flex items-center gap-2">
          <GridSnapshotPill nodes={inv.graphView.nodes} />
        </span>
      }
    >
      <ObjectsSetPanel inv={inv} />
    </DetailSection>
  )
}
